import { defineStore } from 'pinia'
import type { Signal, Project } from '@/mock'

interface DrawersState {
  signalDrawer: Signal | null
  projectDrawer: Project | null
  journeyDrawer: boolean
}

export const useDrawersStore = defineStore('drawers', {
  state: (): DrawersState => ({
    signalDrawer: null,
    projectDrawer: null,
    journeyDrawer: false,
  }),
  actions: {
    openSignal(s: Signal) {
      this.signalDrawer = s
    },
    closeSignal() {
      this.signalDrawer = null
    },
    openProject(p: Project) {
      this.projectDrawer = p
    },
    closeProject() {
      this.projectDrawer = null
    },
    openJourney() {
      this.journeyDrawer = true
    },
    closeJourney() {
      this.journeyDrawer = false
    },
  },
})
